"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductList = exports.ProductCategory = exports.Product = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _offers = require("./components/offers");
var _getStartedMessage = _interopRequireDefault(require("./components/getStartedMessage"));
var Shapes = _interopRequireWildcard(require("./shapes"));
var _excluded = ["products"],
  _excluded2 = ["products", "showEmpty", "startIdx"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var REVOLVING_LINE_OF_CREDIT_PRODUCTS = ['INTEREST_FREE_LOAN', 'PROMOTIONAL_RATE_PLAN'];
var LC_PRODUCTS = ['LC_FIXED_RATE_PLAN', 'LC_TRUE_NO_INTEREST'];
var categorizeProducts = function categorizeProducts() {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var lcProducts = [];
  var revolvingLineOfCreditProducts = [];
  products.forEach(function (product) {
    if (REVOLVING_LINE_OF_CREDIT_PRODUCTS.includes(product.type)) {
      revolvingLineOfCreditProducts.push(product);
    } else if (LC_PRODUCTS.includes(product.type)) {
      lcProducts.push(product);
    }
  });
  return {
    lcProducts: lcProducts,
    revolvingLineOfCreditProducts: revolvingLineOfCreditProducts
  };
};
var ProductCategory = function ProductCategory(props) {
  var products = props.products,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _categorizeProducts = categorizeProducts(products),
    lcProducts = _categorizeProducts.lcProducts,
    revolvingLineOfCreditProducts = _categorizeProducts.revolvingLineOfCreditProducts;
  var totalLCProducts = lcProducts.length;
  var revolvingLineOfCreditProdStartIdx = totalLCProducts > 1 ? totalLCProducts : totalLCProducts + 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, lcProducts.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 product-category"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "product-category__title"
  }, "Installment loans"), /*#__PURE__*/_react.default.createElement("span", {
    className: "product-category__subtext"
  }, "Issued by LendingClub Bank")), /*#__PURE__*/_react.default.createElement(ProductList, Object.assign({
    products: lcProducts
  }, rest))), revolvingLineOfCreditProducts.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 product-category"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "product-category__title"
  }, "Revolving lines of credit"), /*#__PURE__*/_react.default.createElement("span", {
    className: "product-category__subtext"
  }, "Issued by Comenity Capital Bank")), /*#__PURE__*/_react.default.createElement(ProductList, Object.assign({
    products: revolvingLineOfCreditProducts,
    startIdx: revolvingLineOfCreditProdStartIdx
  }, rest))));
};
exports.ProductCategory = ProductCategory;
var ProductList = function ProductList(props) {
  var orignalProducts = props.products,
    showEmpty = props.showEmpty,
    _props$startIdx = props.startIdx,
    startIdx = _props$startIdx === void 0 ? 1 : _props$startIdx,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var products = showEmpty ? orignalProducts : orignalProducts.filter(function (_ref) {
    var offers = _ref.offers;
    return offers.length > 0;
  });
  var disclosureIdx = startIdx;
  var LCProductIdx;
  products.sort(function (a, b) {
    var _a$amountMin, _b$amountMin;
    return parseInt((_a$amountMin = a.amountMin) === null || _a$amountMin === void 0 ? void 0 : _a$amountMin.split('$')[1].replace(',', ''), 10) - parseInt((_b$amountMin = b.amountMin) === null || _b$amountMin === void 0 ? void 0 : _b$amountMin.split('$')[1].replace(',', ''), 10);
  });
  return products && products.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 product-list"
  }, products.map(function (product, idx) {
    var isLCProduct = LC_PRODUCTS.includes(product.type);
    disclosureIdx = isLCProduct && LCProductIdx ? LCProductIdx : disclosureIdx;
    var monthlyIndex;
    if (REVOLVING_LINE_OF_CREDIT_PRODUCTS.includes(product.type)) {
      monthlyIndex = disclosureIdx + 1;
    }
    var index = disclosureIdx;
    var productProps = _objectSpread({
      index: disclosureIdx,
      monthlyIndex: monthlyIndex,
      product: product
    }, rest);
    if (monthlyIndex) {
      disclosureIdx = disclosureIdx + 2;
    } else if (!(isLCProduct && LCProductIdx)) {
      disclosureIdx++;
    }
    if (isLCProduct) {
      LCProductIdx = index;
    }
    return /*#__PURE__*/_react.default.createElement(Product, Object.assign({
      key: idx + product.type
    }, productProps));
  })) : null;
};
exports.ProductList = ProductList;
var getTitle = function getTitle(type, constants) {
  var _constants$type;
  var title = (_constants$type = constants[type]) === null || _constants$type === void 0 ? void 0 : _constants$type.displayName;
  return title;
};
var Product = function Product(_ref2) {
  var product = _ref2.product,
    mobileMode = _ref2.mobileMode,
    index = _ref2.index,
    monthlyIndex = _ref2.monthlyIndex,
    constants = _ref2.constants,
    isLoggedIn = _ref2.isLoggedIn,
    isMedicalMarket = _ref2.isMedicalMarket;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 product"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "product--block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-3 product__summary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "product__summary--box"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "product__summary__title"
  }, getTitle(product.type, constants), /*#__PURE__*/_react.default.createElement("sup", {
    className: "product__summary__sub"
  }, index)), /*#__PURE__*/_react.default.createElement("div", {
    className: "product__summary__description"
  }, product.description))), /*#__PURE__*/_react.default.createElement("div", {
    className: "product__offers col-sm-9"
  }, product.offers && product.offers.length ? /*#__PURE__*/_react.default.createElement(_offers.Offers, {
    offers: product.offers,
    productType: product.type,
    mobileMode: mobileMode,
    monthlyIndex: monthlyIndex
  }) : /*#__PURE__*/_react.default.createElement(_getStartedMessage.default, {
    amountMin: product.amountMin,
    amountMax: product.amountMax,
    isMarketingMode: !isLoggedIn,
    isMedicalMarket: isMedicalMarket
  })))));
};
exports.Product = Product;
ProductList.defaultProps = {
  showEmpty: true,
  isLoggedIn: false,
  isMedicalMarket: false
};

/* istanbul ignore next */
ProductCategory.propTypes = {
  products: _propTypes.default.arrayOf(Shapes.Product),
  mobileMode: _propTypes.default.bool,
  showEmpty: _propTypes.default.bool,
  constants: _propTypes.default.object,
  isLoggedIn: _propTypes.default.bool,
  isMedicalMarket: _propTypes.default.bool
};

/* istanbul ignore next */
ProductList.propTypes = {
  products: _propTypes.default.arrayOf(Shapes.Product),
  showEmpty: _propTypes.default.bool,
  mobileMode: _propTypes.default.bool,
  constants: _propTypes.default.object,
  startIdx: _propTypes.default.number,
  isLoggedIn: _propTypes.default.bool,
  isMedicalMarket: _propTypes.default.bool
};

/* istanbul ignore next */
Product.propTypes = {
  product: Shapes.Product,
  mobileMode: _propTypes.default.bool,
  index: _propTypes.default.number,
  monthlyIndex: _propTypes.default.number,
  constants: _propTypes.default.object,
  isLoggedIn: _propTypes.default.bool,
  isMedicalMarket: _propTypes.default.bool
};
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');